import { useCallback, useEffect, useRef, useState } from 'react'

import { HELPERS } from '@Components/modals/PageHelpers'
import { MODIFIERS } from '@Components/modals/PageVariables'
import { useGlobalStore } from '@Stores/global'
import appStore from 'stores/app'
import { getDateFormats } from 'utils'

export function usePageVariables(enabled = true) {
  const { customFields: { getFields }, metaFields: { getFields: getMetaFields } } = useGlobalStore()
  const [fields, setFields] = useState([])
  const loaded = useRef(false)

  const loadFields = useCallback(async () => {
    const fields = await appStore.getFields()
    const customFields = await getFields({ parse: true })
    const metaFields = await getMetaFields()

    const extraFields = []
    for (const customField of customFields) {
      if (customField.private) {
        continue
      }

      extraFields.push(customField.key)
      if (customField.type === 'date') {
        extraFields.push(...getDateFormats(customField.key))
      }
    }

    for (const metaField of metaFields) {
      extraFields.push(metaField.key)
    }

    const allFields = [...fields, ...extraFields].reduce((fields, field) => {
      if (field.endsWith('_urlencoded') || field.startsWith('cf_')) {
        field = field.replace('_urlencoded', '')
        const opts = fields[field] = fields[field] || {}
        opts.encodable = true
        opts.bidid = true
        opts.dba = true
        opts.bid = true
      } else if (field.endsWith('_jsescape')) {
        field = field.replace('_jsescape', '')
        const opts = fields[field] = fields[field] || {}
        opts.escapable = true
      } else if (field.endsWith('_md5')) {
        field = field.replace('_md5', '')
        const opts = fields[field] = fields[field] || {}
        opts.md5 = true
      } else if (field.endsWith('_optout')) {
        field = field.replace('_optout', '')
        const opts = fields[field] = fields[field] || {}
        opts.optout = true
      } else {
        fields[field] = fields[field] || {}
      }
      return fields
    }, {})

    setFields(Object.entries(allFields))
  }, [getFields, getMetaFields])

  useEffect(() => {
    if (!enabled || loaded.current) {
      return
    }

    loaded.current = true
    loadFields()
  }, [enabled, loadFields])

  return fields
}

export const getPageMergetags = fields => [
  ...fields.flatMap(([field, opts]) => [
    field,
    ...MODIFIERS.filter(({ key }) => opts[key]).map(({ suffix }) => `${field}${suffix}`),
  ]),
  ...HELPERS.map(helper => `${helper}()`),
]
